import moment from 'moment'

import 'moment/locale/nl'
import 'moment/locale/de'
import 'moment/locale/fr'
import 'moment/locale/es'
import 'moment/locale/sv'
import 'moment/locale/da'
import 'moment/locale/it'
import 'moment/locale/pl'
import 'moment/locale/pt'
import 'moment/locale/fi'
import 'moment/locale/nn'
import 'moment/locale/cs'

moment.locale('en')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
